export const CoreSymbols = {
  router: "$router",
  store: "$store",
  vuetify: "$vuetify",
};
